"use strict";
// Copyright (c) StrangeBee 2024
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ParentController_1 = __importDefault(require("../ParentController"));
class ObservableController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/case/:objectId/observable',
            alertCreate: '/v1/alert/:objectId/observable',
            edit: '/v1/observable/:objectId',
            delete: '/v1/observable/:objectId',
            addShare: '/v1/observable/:observableId/shares',
            deleteShare: '/v1/observable/:observableId/shares',
            bulkEdit: '/v1/observable/_bulk',
            downloadAttachment: '/v1/observable/:observableId/attachment/:objectId/download?asZip=true',
        };
    }
    create(data, caseId) {
        const { attachment } = data, observable = __rest(data, ["attachment"]);
        let attachmentData = {};
        const formData = new FormData();
        if (attachment instanceof Blob) {
            formData.set('attachment', attachment);
        }
        else {
            attachmentData = attachment ? { attachment } : {};
        }
        formData.set('_json', JSON.stringify(Object.assign(Object.assign({}, observable), attachmentData)));
        return super.create(formData, caseId);
    }
    alertCreate(data, alertId) {
        const { attachment } = data, observable = __rest(data, ["attachment"]);
        let attachmentData = {};
        const formData = new FormData();
        if (attachment instanceof Blob) {
            formData.set('attachment', attachment);
        }
        else {
            attachmentData = attachment ? { attachment } : {};
        }
        formData.set('_json', JSON.stringify(Object.assign(Object.assign({}, observable), attachmentData)));
        return this.manager.post({ url: this.endpoints.alertCreate, params: { objectId: alertId } }, formData);
    }
    addShare(organisations, observableId) {
        return this.manager.post({ url: this.endpoints.addShare, params: { observableId } }, { organisations });
    }
    deleteShare(organisations, observableId) {
        return this.manager.delete({ url: this.endpoints.deleteShare, params: { observableId } }, { organisations });
    }
    getUrlDownloadAttachment(opt) {
        return Object.entries(opt).reduce((url, [key, value]) => url.replace(`:${key}`, value), this.endpoints.downloadAttachment);
    }
    multiEdit(observableIds, fieldsEdited) {
        return this.manager.patch({
            url: this.endpoints.bulkEdit,
        }, Object.assign({ ids: observableIds }, fieldsEdited));
    }
    multiDelete(observablesId) {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.all(observablesId.map((objectId) => __awaiter(this, void 0, void 0, function* () {
                yield this.delete(objectId);
            })));
        });
    }
}
exports.default = ObservableController;
